export default {
    closeButton: "Close",
    helpLabel: "Help",
    homeLabel: "Home",
    logoutButton: "Logout",
    notificationsLabel: "Notifications",
    noUserDataLabel: "No user data available",
    settingsLabel: "Settings",
    userLabel: "User",
    userProfileLinkText: "User Profile"
};
